<template>
	<div>
		<h3 class="ch-block-title text-left text-uppercase mb-0">Summary</h3>
		<div class="summary-column d-flex flex-wrap align-items-center bb-0">
			<p class="d-flex flex-basis-100">
				<span class="sm-label flex-grow-1">Products</span>
				<span class="sm-price">{{
					formatPrice(productCosts, true)
				}}</span>
			</p>
			<p class="d-flex flex-basis-100">
				<span class="sm-label flex-grow-1">Shipping</span>
				<span class="sm-price">Free</span>
			</p>

			<p
				class="sm-you-save d-flex flex-basis-100 font-weight-500"
				v-if="discount > 0"
			>
				<span class="sm-label flex-grow-1"
					>You Save ({{ discount }}% OFF)</span
				>
				<span class="sm-price c-green">{{
					formatPrice(savings, true)
				}}</span>
			</p>
			<p class="sm-total d-flex flex-basis-100 pb-2 font-weight-500">
				<span class="sm-label flex-grow-1">Total</span>
				<span class="sm-price">{{ formatPrice(total, true) }}</span>
			</p>
			<span
				class="sm-cta mt-4 pulsate-fwd2 gtm3_precheckout_cta"
				id="cta_summary"
				@click="visitCheckout(true)"
				><i class="fas fa-shopping-cart"></i>Proceed To Checkout</span
			>
			<!-- <p class="sm-safe-text mt-4">
				<span>Guaranteed Safe Checkout</span>
			</p>
			<img src="@/assets/img/v1/secure2.png" alt="Safe Checkout Image" /> -->
		</div>
	</div>
</template>

<script>
export default {
	props: {
		checkoutPath: {
			type: String,
			default: "https://ohowatch.com",
		},
		prices: {
			type: Object,
			default: () => {},
		},
		locale: {
			type: Object,
			default: () => {},
		},
		discount: {
			type: Number,
			default: 0,
		},
		beacon: {
			type: Object,
			default: () => {
				return {
					send: false,
					url: "",
				}
			},
		},
	},
	computed: {
		productCosts() {
			return this.prices.packageCosts + this.prices.extraCosts
		},
		savings() {
			return 0 - (this.prices.packageSavings + this.prices.extraSavings)
		},
		total() {
			return this.productCosts - -this.savings
		},
	},
	methods: {
		formatPrice(price, iso = false) {
			return new Intl.NumberFormat(this.locale.language, {
				style: "currency",
				currency: this.locale.currency,
				currencyDisplay: iso === true ? "symbol" : "narrowSymbol",
			}).format(parseFloat(price))
		},
		visitCheckout(newTab) {
			if (this.beacon.send && this.beacon.url.length > 3) {
				navigator.sendBeacon(
					"https://trk.topgadgetreport.com/?flux_action=1"
				)
			}
			window.open(this.checkoutPath, newTab == true ? "_blank" : "_self")
		},
	},
}
</script>

<style lang="scss" scoped></style>
